import { FC } from 'react';
import { useStyles } from './styles';
import { Grid, Card, CardContent, Box, Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import GoogleSvg from '../../../assets/googlelogo.svg';
// import { useHistory } from 'react-router-dom';
// import { handleCompanyUrl } from 'utils/organizationUtils';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export const OdicTable: FC = observer(() => {
  const classes = useStyles();
  // const history = useHistory();
  const mockDataPers1 = [
    { logo: GoogleSvg, provide: 'Google', alt: 'google' },
    // { logo: ZoomSvg, provide: 'zoom', alt: 'zoom', id: zoomId || null },
    // { logo: MicrosoftSvg, provide: 'microsoft', alt: 'microsoft', id: microsoftId || null },
    // { logo: GithubSvg, provide: 'github', alt: 'github', id: githubId || null },
  ];
  // const onhandleClick = () => {
  //     history.push(handleCompanyUrl('/odic/info'));
  // }
  //    history.push(handleCompanyUrl('/apps/google'));
  return (
    <>
      <div>
        {mockDataPers1.map((item, index) => {
          // const getAppLogo = (appName: string) => {
          //     switch (appName.toLowerCase()) {
          //         case 'google':
          //             return GoogleSvg;
          //         default:
          //             return GoogleSvg;
          //     }
          // };

          const getCardClass = (appName: string) => {
            let className = classes.card;
            // Since these are connected apps, they all have approved status
            className += ` ${classes.approvedCard}`;
            return className;
          };
          return (
            <>
              <div className={classes.page}>
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={getCardClass(item.provide)}>
                    <CardContent>
                      <CheckCircleIcon className={`${classes.topIcon} ${classes.approvedIcon}`} />

                      <div className={classes.appRow}>
                        <img src={item.logo} alt={'app'} className={classes.appIcon} />
                        <Box>
                          <Typography className={classes.appName}>{item.provide}</Typography>
                          <Typography className={classes.appDesc}>Access granted</Typography>
                        </Box>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
});
